
import z from "zod";

export const AppConfigSchema = z.object({
  webapiurl: z.string(),
  enableVOD: z.boolean(),
  enableMosaics: z.boolean(),
  enableSessions: z.boolean(),
  enableHls: z.boolean()
})
export type AppConfig = z.infer<typeof AppConfigSchema>

